const scrollToJustAbove = (element: HTMLElement, margin = 80) => {
  const initialScroll = document.body.getBoundingClientRect();
  let dims = element.getBoundingClientRect();
  const finalScroll = dims.top - initialScroll.top;
  window.scrollTo(window.scrollX, finalScroll - margin);
};
export default scrollToJustAbove;
